import { render } from "./Steps2.vue?vue&type=template&id=6f34a091"
import script from "./Steps2.vue?vue&type=script&lang=js"
export * from "./Steps2.vue?vue&type=script&lang=js"
script.render = render

export default script